import { render, staticRenderFns } from "./receive-manager.vue?vue&type=template&id=1b9b6564&scoped=true&"
import script from "./receive-manager.vue?vue&type=script&lang=js&"
export * from "./receive-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9b6564",
  null
  
)

export default component.exports